import React, {useState, useRef} from 'react'

import {AiFillCamera} from 'react-icons/ai'
import {useAppend, useUploadPhoto} from '../hooks/mutations'
import { updateDevices, keyId } from '../lib/utils';
import {useStateContext} from '../context/StateContext';
import {Loading, VisDiv} from '../components';
import { successAlert, errorAlert } from '../lib/utils';
import { v4 as uuidv4, v4 } from 'uuid';
import { optimizeImage } from '../hooks/imageOptimizer';


 

const InsertPhotoSanity = ({saveSanityFn}) => 
{
    const [loading, setLoading] = useState(false);
    const [imageAsset, setImageAsset] = useState();
    const [wrongImageType, setWrongImageType] = useState(false); 
    const hiddenFileInput = React.useRef(undefined);
    const testing = false
    const {devices, sUser} = useStateContext();


  const saveImageBase64 = (file, base64, position) => {
    const doc = {
      _type: 'object',
      _key: keyId(),
      src: base64, 
      fileType: file?.type,
      fileName: file?.name,
      longitude:position?.coords?.longitude,
      latitude:position?.coords?.latitude,
      postedOn: Date.now(), 
      postedBy: { _type: 'postedBy', _ref: sUser._id }, 
      status:"ATTIVO",

    }
    //console.log("DOC IMAGE", doc)
    saveSanityFn(doc)
    //addPhoto({documentId:destination._id, arrayName:'image',doc: doc})
  }

    const {mutate: uploadPhotoAsset} = useUploadPhoto({
      onSuccess:(asset)=>{
      setImageAsset(asset);
      saveImage(asset)
      setLoading(false);
    },
    onError:()=>{
      errorAlert("UPLOAD FOTO NON RIUSCITO")
    }
  
  })

    const {mutate: addPhoto} = useAppend({
      onError: (err)=>{
        console.error("salvataggio immagine non riuscito:",err.message)
        errorAlert("SALVATAGGIO IMMAGINE NON RIUSCITO, RIPROVARE")
      
      }
    }
  )


const onTestClick = () =>{
   
  //console.log("array name index:", arrayNameIndex, "currentDevice", currentDevice)
}

    const handleClick = event => {
      hiddenFileInput.current.click();
    };


    const saveImage = (document) => {
      const doc = {
        _type: 'image',
        _key: keyId(),
        asset: {
            _type: 'reference',
            _ref: document?._id,
            _key: keyId()
          },
        
      }
      saveSanityFn(doc)

/*         addPhoto({documentId: destination._id, arrayName:'image',doc: doc})
        const updatedDoc = destination?.image ? {...destination, image:[...destination?.image, doc]} : {...destination, image:[doc]}
        setDestination(updatedDoc)
        if (destinationType =="nonConformity"){
            console.log("inserted photo nonConformity")
            const filteredDeviceNonConformities = deviceNonConformities.filter?.(x=>x?._id !== destination?._id)
            setDeviceNonConformities([...filteredDeviceNonConformities, updatedDoc])
          } else {
            console.log("inserted photo device")
            updateDevices(devices, setDevices, currentDevice, updatedDoc)
          } */
    }




    const deletePhoto = () => {
        //console.log("delete photo")
    }

    const uploadPhoto = async (e) => {
        try {
            const selectedFile = e.target.files[0];
            
            // Validate file type first
            const validTypes = ['image/png', 'image/heic', 'image/svg', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp', 'image/tiff'];
            if (!validTypes.includes(selectedFile.type)) {
                setLoading(false);
                setWrongImageType(true);
                errorAlert("il formato della foto non è valido");
                return;
            }

            setWrongImageType(false);
            setLoading(true);

            // Optimize image before uploading to Sanity
            const optimizedFile = await optimizeImage(selectedFile);
            const asset = {fileType: "image", file: optimizedFile};
            
            console.log("Uploading optimized photo", asset);
            uploadPhotoAsset(asset);
        } catch (error) {
            console.error("Error optimizing photo:", error);
            setLoading(false);
            errorAlert("Errore durante il caricamento dell'immagine");
        }
    }

    if (loading) 
    return <Loading/>;
  return (
    <div>
      <VisDiv rules={[testing]}>
        <button onClick={onTestClick}>test</button>  
      </VisDiv>     

      <button onClick={handleClick} className='round-button-no-hover'>
        <AiFillCamera
        size={25}
        color={"white"}
        />
      </button>
      <input
        type="file"
        name="upload-image"
        ref={hiddenFileInput}
        style={{display:"none"}}
        onChange={(e)=>uploadPhoto(e)}
        className="insert-photo-button"
      />
    </div>
  )
}

export default InsertPhotoSanity
